import AppAbortController from '@/api/abort-controller'
import ApiHandler from '@/api/base'

const abortController = new AppAbortController()

class ElementProgressApiHandler extends ApiHandler {
  /**
   *
   * @async
   * @method
   * @param {Object} [requestPayload={}]
   * @param {number} requestPayload.elementId
   * @param {number|null} [requestPayload.columnCount=5]
   * @param {number|null} [requestPayload.shiftSize=1].
   * @param {string|number|null} [requestPayload.viewPointLastDate=undefined]
   *
   * @param {Object} [requestConfig={}]
   * @param {boolean} [requestConfig.ignoreCancellation=false]
   *
   * @returns {Promise<any>}
   */
  async getElementProgress(
    { elementId, columnCount = 5, shiftSize = 1, viewPointLastDate = undefined } = {},
    { ignoreCancellation = false } = {}
  ) {
    let signal

    if (!ignoreCancellation) {
      signal = abortController.getSignal(this.constructor.name, 'getElementProgress')
    }

    const { data } = await this.http.get('/elements/progress', {
      params: {
        elementId,
        columnCount,
        shiftSize,
        viewPointLastDate
      },
      signal
    })

    return data
  }

  async getElementProgressForDescription({ elementId }) {
    const { data } = await this.http.get('/elements/progressDescription', {
      params: {
        elementId
      }
    })
    return data
  }

  async updateThresholdForPeriod({ elementId, startDate, endDate, targetValue, viewConfig }) {
    const { data } = await this.http.put('/elements/target', {
      elementId,
      startDate,
      endDate,
      targetValue,
      viewConfig
    })

    return data
  }
}

export default ElementProgressApiHandler
